import { createContext, useState, useContext } from 'react';
import jwt_decode from 'jwt-decode';

const AuthContext = createContext({
  token: '',
  isAuthenticated: false,
  authenticate: (token) => {},
  logout: () => {},
  userID: String,
});

export function AuthContextProvider({ children }) {
  const tokenStore = localStorage.getItem('libyanaToken');
  if (tokenStore) {
    const decodedToken = jwt_decode(tokenStore);
    if (decodedToken.exp * 1000 < new Date().getTime()) logout();
  }
  const [authToken, setAuthToken] = useState(tokenStore);
  const [userID, setUserID] = useState();

  function authenticate(token) {
    var decoded = jwt_decode(token);
    setAuthToken(token);
    localStorage.setItem('libyanaToken', token);
    setUserID(decoded.id);
  }

  function logout() {
    setAuthToken(null);
    localStorage.removeItem('libyanaToken');
    setUserID(null);
  }

  const value = {
    token: authToken,
    isAuthenticated: !!authToken,
    authenticate: authenticate,
    logout: logout,
    userID: userID,
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  return context;
};
